import React, { useState, useCallback } from "react";
import "../report2025/styles/global.css";
import Report2025App from "../report2025/Report2025App";
const PASS = "humd@2025";
const SESSION_KEY = "report2025_auth";

function PasswordGate({ onSuccess }) {
  const [value, setValue] = useState("");
  const [error, setError] = useState(false);

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      if (value === PASS) {
        sessionStorage.setItem(SESSION_KEY, "1");
        onSuccess();
      } else {
        setError(true);
      }
    },
    [value, onSuccess],
  );

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#111827",
        fontFamily: "'Inter', system-ui, sans-serif",
      }}
    >
      <form
        onSubmit={handleSubmit}
        style={{
          background: "#1F2937",
          borderRadius: 12,
          padding: "48px 40px",
          width: "100%",
          maxWidth: 380,
          textAlign: "center",
          boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
        }}
      >
        <div
          style={{
            fontFamily: "'Playfair Display', Georgia, serif",
            fontSize: 28,
            fontWeight: 600,
            color: "#2F9E5C",
            marginBottom: 8,
          }}
        >
          humd
        </div>
        <p
          style={{
            fontSize: 13,
            color: "rgba(255,255,255,0.45)",
            marginBottom: 32,
          }}
        >
          2025 Investor Update. Password Required
        </p>
        <input
          type="password"
          placeholder="Enter password"
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            setError(false);
          }}
          autoFocus
          style={{
            width: "100%",
            padding: "12px 16px",
            fontSize: 15,
            borderRadius: 6,
            border: error ? "1.5px solid #ED636E" : "1.5px solid #374151",
            background: "#111827",
            color: "#fff",
            outline: "none",
            transition: "border-color 0.2s",
          }}
        />
        {error && (
          <p style={{ color: "#ED636E", fontSize: 13, marginTop: 8 }}>
            Incorrect password
          </p>
        )}
        <button
          type="submit"
          style={{
            marginTop: 20,
            width: "100%",
            padding: "12px 0",
            background: "#2F9E5C",
            color: "#fff",
            border: "none",
            borderRadius: 6,
            fontSize: 14,
            fontWeight: 600,
            cursor: "pointer",
            transition: "background 0.15s",
          }}
        >
          Access Report
        </button>
      </form>
    </div>
  );
}

export default function Report2025() {
  const [authed, setAuthed] = useState(
    () => sessionStorage.getItem(SESSION_KEY) === "1",
  );

  if (!authed) return <PasswordGate onSuccess={() => setAuthed(true)} />;

  return (
    <div className="report2025-scope">
      <Report2025App />
    </div>
  );
}
